import { useTranslation } from "react-i18next";

export default function CompareSection() {
  const { t } = useTranslation();

  const rows = [
    { method: "compare.row1_method", time: "compare.row1_time", org: "compare.row1_org", result: "compare.row1_result", highlight: false },
    { method: "compare.row2_method", time: "compare.row2_time", org: "compare.row2_org", result: "compare.row2_result", highlight: false },
    { method: "compare.row3_method", time: "compare.row3_time", org: "compare.row3_org", result: "compare.row3_result", highlight: true },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3 md:mb-4">
            {t("compare.title")}
          </h2>
        </div>

        <div className="overflow-x-auto rounded-lg border border-background-200/70 bg-background-50">
          <table className="w-full text-sm md:text-base">
            <thead>
              <tr className="bg-secondary-100">
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">{t("compare.col1")}</th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">{t("compare.col2")}</th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">{t("compare.col3")}</th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">{t("compare.col4")}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr
                  key={idx}
                  className={`border-t border-background-200/70 ${
                    row.highlight ? "bg-primary-50/70" : "hover:bg-background-100"
                  }`}
                >
                  <td className="px-5 py-4 font-medium text-foreground-800 whitespace-nowrap">
                    {row.highlight && (
                      <span className="inline-block w-2 h-2 rounded-full bg-primary-500 mr-2 align-middle"></span>
                    )}
                    {t(row.method)}
                  </td>
                  <td className="px-5 py-4 text-foreground-700 whitespace-nowrap">{t(row.time)}</td>
                  <td className="px-5 py-4 text-foreground-700 whitespace-nowrap">{t(row.org)}</td>
                  <td className="px-5 py-4 whitespace-nowrap">
                    <span
                      className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${
                        row.highlight
                          ? "bg-accent-100 text-accent-700"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {t(row.result)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}